<template>
	<Card>
		<Row style="padding-top: 20px;">
			<Form :label-width="80">
				<FormItem label="时间区间">
					<RadioGroup v-model="timePeriod" @on-change="search">
						<Radio label="0"><span>不限</span></Radio>
						<Radio label="1"><span>今日</span></Radio>
						<Radio label="2"><span>昨日</span></Radio>
						<Radio label="3"><span>本周</span></Radio>
						<Radio label="4"><span>上周</span></Radio>
						<Radio label="5"><span>本月</span></Radio>
						<Radio label="6"><span>上月</span></Radio>
						<Radio label="7"><span>自定义</span></Radio>
						<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
							placeholder="选择日期" style="width: 200px"></DatePicker>
					</RadioGroup>
				</FormItem>
				<FormItem label="统计方式">
					<RadioGroup v-model="statisticsWay" @on-change="search">
						<Radio :label="1"><span>媒体代码</span></Radio>
						<Radio :label="2"><span>媒体渠道</span></Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="城市">
					<Select v-model="city" style="width:200px" placeholder="请选择城市" @on-change="search">
						<Option v-for="item in cityList" :value="item.city" :key="item.city">
							{{ item.city }}
						</Option>
					</Select>
					<Select v-model="shopId" style="width:200px" placeholder="请选择公司" @on-change="search">
						<Option v-for="item in shopList" :value="item.value" :key="item.value">
							{{ item.label }}
						</Option>
					</Select>
					<Button class='ivu-btn-circle' style="margin-left: 20px" type="primary"
						@click="initSearch">重置</Button>
					<Button class='ivu-btn-circle' style="margin-left: 20px" type="primary"
						@click="()=>{monthConventModal = true}">查看月份转化</Button>
				</FormItem>
			</Form>
		</Row>
		<Row>
			<div class="multiple" style="width: 100%">
				<Table stripe border :columns="columns" :data="datas" ref="table" >
					<template slot-scope="{ row }" slot="name">
						<span v-if="statisticsWay==1">{{row.name}}</span>
						<span v-if="statisticsWay==2">{{row.medium_name}}</span>
					</template>
					<template slot-scope="{ row }" slot="start_0">
						<span>{{row.start_0}}</span>
						<div>
							<span style="color: #0092FF;">({{row.start_0_rate}})</span>
						</div>
					</template>
					<template slot-scope="{ row }" slot="start_1">
						<span>{{row.start_1}}</span>
						<div>
							<span>({{row.start_1_rate}})</span>
						</div>
					</template>
					<template slot-scope="{ row }" slot="start_2">
						<span>{{row.start_2}}</span>
						<div>
							<span>({{row.start_2_rate}})</span>
						</div>
					</template>
					<template slot-scope="{ row }" slot="start_2_up">
						<span>{{row.start_2_up}}</span>
						<div>
							<span>({{row.start_2_plus_rate}})</span>
						</div>
					</template>
					<template slot-scope="{ row }" slot="start_3">
						<span>{{row.start_3}}</span>
						<div>
							<span>({{row.start_3_rate}})</span>
						</div>
					</template>
					<template slot-scope="{ row }" slot="start_4">
						<span>{{row.start_4}}</span>
						<div>
							<span>({{row.start_4_rate}})</span>
						</div>
					</template>
					<template slot-scope="{ row }" slot="start_5">
						<span>{{row.start_5}}</span>
						<div>
							<span>({{row.start_5_rate}})</span>
						</div>
					</template>
					<template slot-scope="{ row }" slot="start_3_plus">
						<span>{{row.start_3_plus}}</span>
						<div>
							<span style="color: #0092FF;">({{row.start_3_plus_rate}})</span>
						</div>
					</template>
				</Table>
			</div>
		</Row>
		<Modal v-model="monthConventModal" width="1200" title="月份转化分析">
			<SynthesizeAnalyse></SynthesizeAnalyse>
		</Modal>
	</Card>
</template>
<script>
	import {
		getAllMediumCode,
		getAllMedium,
		getMediaStatics,
		getAllShop,
		getAllCity,
		newGetMediaStatics,
		mediaStatics
	} from "../../api/runSet";
	import SynthesizeAnalyse from "../statistics/SynthesizeAnalyse.vue"
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "media_statistics",
		components: {
			SynthesizeAnalyse
		},

		data() {
			return {
				modal: false,
				timePeriod: '1',
				statisticsWay: 1,
				timePeriodDate: [],
				monthConventModal: false,
				city: '',
				cityList: '',
				shopId: '',
				shopList: [],
				datas: [],
				columns: [{
						"title": "媒体代码",
						"slot": "name",
						"align": "center",
						"width": 120,
						fixed: 'left',
					},
					{
						"title": "成本",
						"key": "money",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "当月创收",
						"key": "current_repay_money",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "拓客创收",
						"key": "introduce_repay_money",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "总创收",
						"key": "history_repay_money",
						"align": "center",
						"width": 100,
						sortable: true
					},
					{
						"title": "平均成本",
						"key": "average_cost",
						"align": "center",
						"width": 90,
						"sortable": true
					},
					{
						"title": "数量",
						"key": "nums",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "0星",
						"slot": "start_0",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "1星",
						"slot": "start_1",
						"align": "center",
						"width": 100,
					},
					{
						"title": "2星",
						"slot": "start_2",
						"align": "center",
						"width": 100
					},
					{
						"title": "2星+",
						"slot": "start_3",
						"align": "center",
						"width": 100
					},
					{
						"title": "3星",
						"slot": "start_4",
						"align": "center",
						"width": 100
					},
					{
						"title": "4星",
						"slot": "start_5",
						"align": "center",
						"width": 100,
					},
					{
						"title": "3星以上",
						"slot": "start_3_plus",
						"align": "center",
						"width": 100,
					},
					{
						"title": "待跟进",
						"key": "status_2",
						"align": "center",
						"width": 75,
					},
					{
						"title": "跟进中",
						"key": "status_3",
						"align": "center",
						"width": 75,
					},
					{
						"title": "签约率",
						"key": "status_sign_rate",
						"align": "center",
						"width": 75,
					},
					{
						"title": "放款率",
						"key": "status_loan_rate",
						"align": "center",
						"width": 75,
					},
					{
						"title": "公共池",
						"key": "pool_nums",
						"align": "center",
						"width": 75,
					},
					{
						"title": "公海",
						"key": "sea_nums",
						"align": "center",
						"width": 60,

					},
					{
						"title": "已上门",
						"key": "the_door_nums",
						"align": "center",
						"width": 75,
					},
					{
						"title": "录入成本",
						"key": "price",
						"align": "center",
						"width": 100,
						"sortable": true
					},
					{
						"title": "上门率",
						"key": "status_door_rate",
						"align": "center",
						"width": 75,
					}
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			initSearch() {
				this.mediumCodeId = '';
				this.statisticsWay = 1;
				this.mediumId = '';
				this.timePeriod = "1";
				this.timePeriodDate = [];
				this.shopId = '';
				this.city = '';
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllShop(that, data);
				that.shopList = res.data.list;
				res = await getAllCity(that, data);
				that.cityList = res.data.list;
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await newGetMediaStatics(that, data);
				that.datas = res.data.list;
			},
			search() {
				this.getList();
			}
		},
	}
</script>
<style scoped lang="less">
	.ranking_title {
		display: flex;

		div {
			width: 12%;
			height: 50px;
			text-align: center;
			line-height: 50px;
			font-size: 18px;
			font-weight: bold;
			color: #686868;
		}
	}

	.ranking_list {
		display: flex;
		margin: 20px 0;

		div {
			width: 12%;
			height: 50px;
			text-align: center;
			line-height: 50px;
			font-size: 18px;
			color: #9F9F9F;
		}
	}

	.ranking1 {
		background: url("../../assets/images/ranking1.png");
		color: #000066;
	}

	.ranking_img {
		font-size: 40px;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #00aa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
